// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type {
    GetProductDetailsFindNoMainProductQuery,
    BaseResponseListProductDetailFoundResponse,
} from '../../types';

/**
 * findNoMainProduct
 *
 * @export
 * @tags product-detail-controller
 * @link [GET] /productDetails/findNoMainProduct
 */
export function getProductDetailsFindNoMainProduct(): Promise<BaseResponseListProductDetailFoundResponse>;
export function getProductDetailsFindNoMainProduct(
    options: ApiOptions<never, GetProductDetailsFindNoMainProductQuery>
): Promise<BaseResponseListProductDetailFoundResponse>;
export function getProductDetailsFindNoMainProduct(
    options?: ApiOptions<never, GetProductDetailsFindNoMainProductQuery>
): Promise<BaseResponseListProductDetailFoundResponse> {
    return request<never, never, GetProductDetailsFindNoMainProductQuery>(
        '/productDetails/findNoMainProduct',
        { ...options, method: 'get', __$requestCalleeName: 'getProductDetailsFindNoMainProduct' }
    );
}

export const meta = [
    {
        tags: ['product-detail-controller'],
        path: '/productDetails/findNoMainProduct',
        method: 'get',
    },
];
